import styled from 'styled-components'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const TotalAppointmentsCardContainer = styled.div`
    background: linear-gradient(
        140deg,
        rgba(0, 92, 217, 1) 0%,
        rgba(255, 3, 134, 1) 100%
    );
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    width: 100%;
    min-height: 284px;
    border-radius: 20px;
    padding: 42px 8px;
`

export const TotalAppointmentsInfoWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 16px;
`

export const TotalAppointmentsIcon = styled(FontAwesomeIcon)<{
    windowWidth: number
}>`
    color: #fff;
    width: ${({ windowWidth }) =>
        windowWidth < 1324 ? '1em' : '0.75em'} !important;
`

export const TotalAppointmentInfoText = styled.p<{ windowWidth: number }>`
    color: #fff;
    font-family: Myraid Pro, sans-serif;
    font-size: ${({ windowWidth }) => (windowWidth < 1324 ? '1rem' : '0.7rem')};
    text-align: left;
`

export const NoAppointmentsLabel = styled.p`
    text-align: center;
    margin: 4em 10px;
    font-weight: 700;
    color: #fff;
`
